import {
  ProductsTemplate,
  PtgFeaturesTemplate,
  PRODUCTS_TEMPLATE_ID,
  PTG_FEATURES_TEMPLATE_ID
} from '../templates/index.js';
import { get, isEmpty } from 'lodash';
import React from 'react';
import { useDetermineEFlyerThemeApplication } from '../common';
import { NotFound } from 'app/layout/components';
import { useContentModel } from 'app/content/hooks';

const EFlyerResolver = props => {
  const { location } = props;
  const themeApplication = useDetermineEFlyerThemeApplication();

  const eflyerPath = '/eflyer';
  const pdfPath = '/pdf';
  const pathname = location.pathname;

  let contentPath = stripPathSegment(pathname, pdfPath);

  const { content, loading } = useContentModel(null, { uri: contentPath });

  if (loading || isEmpty(content)) {
    return <div>Loading...</div>;
  }

  const modelId = get(content, 'model.id', null);
  if (!modelId) {
    return <NotFound />;
  }
  if (modelId === PRODUCTS_TEMPLATE_ID) {
    return (
      <ProductsTemplate content={content} themeApplication={themeApplication} />
    );
  } else if (modelId === PTG_FEATURES_TEMPLATE_ID) {
    return (
      <PtgFeaturesTemplate
        content={content}
        themeApplication={themeApplication}
      />
    );
  }
};

function stripPathSegment(path, segment) {
  return path.startsWith(segment) ? path.substring(segment.length) : path;
}

export default EFlyerResolver;
export { EFlyerResolver };
